<template>
    <div class="content-card-body">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-12 d-flex justify-content-center p-1" v-for="(item,index) in getGames.games"  v-bind:key="index">
          <router-link :to="`/slot/${item.games_provider_id}`" >
                <img :src="require('@/assets/images/casino/banner/'+item.games_provider_id+'.png')" class="img-fluid">
              </router-link >
        </div>
      </div>
        <!-- <ul class="game-list">
            <li  v-for="(item,index) in getGames.games"  v-bind:key="index">
              <router-link :to="`/slot/${item.games_provider_id}`" >
                <img :src="require('@/assets/images/casino/banner/'+item.games_provider_id+'.png')" class="img-fluid">
              </router-link >
            </li>
        </ul> -->
    </div>
</template>
<script>
import { ApiService } from '@/utils'
import { mapState, mapActions, mapGetters } from 'vuex'
const client = new ApiService({})

export default {
  async mounted () {
    if (process.env.VUE_APP_CASINO_ENABLE.toLowerCase().trim() === 'false') {
      this.$router.push('/member')
    }
    try {
      await this.getGamesList({
        type: 4
      })
    } catch (error) {
    }
  },
  computed: {
    ...mapGetters([
      'getGames',
      'getGameUrl'
    ]),
    ...mapState({
      isMember: (state) => state.authModule.isMember
    })
  },
  methods: {
    ...mapActions(['getGamesList', 'getGamesUrl', 'setGameDepositCreditAll']),
    async reqStartGame (gameId, game_img, game_name) {
      const resp = await client.post('/game/request/start', JSON.stringify({
        id: gameId
      }))
      if (resp.status_code === 'SUCCESS') {
        this.link_to_game = process.env.VUE_APP_CASINO_URL + '/' + localStorage.getItem('client_id') + '/' + resp.data._token
        this.$swal({
          text: 'คุณต้องการเข้าเล่น ' + game_name + ' ?',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ปิด',
          imageUrl: game_img,
          imageWidth: '100%'
        }).then((result) => {
          if (result.isConfirmed) {
            window.open(process.env.VUE_APP_CASINO_URL + '/' + localStorage.getItem('client_id') + '/' + resp.data._token)
          }
        })
      }
    }
  }
}
</script>

<style>

</style>
